import { ToastMessage } from "components/common";
import { create } from "ipfs-http-client";
import Papa from "papaparse";
import { app } from "./constant";

let WAValidator = require("public-address-validator");

export class CommonUtility {
  static currencyFormat = (value, currency) =>
    isNaN(value || 0)
      ? value
      : new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency || "USD",
      }).format(value || 0);

  static isNotEmpty = (item) =>
    item !== undefined && item !== null && item !== "" && item.length !== 0;

  static truncateString = (text, ellipsisString) =>
    (text || "").length > ellipsisString
      ? text.substring(0, ellipsisString) + "..."
      : text;

  static numberWithCommas = (x) =>
    x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  static handleMulDecimals = (
    value: any,
    tokenDecimals: number,
    decimals: number
  ) => {
    return (value * 10 ** tokenDecimals).toFixed(decimals).toString();
  };

  static handleDivDecimals = (
    value: any,
    tokenDecimals: number,
    decimals?: number
  ) => {
    return (value / 10 ** tokenDecimals).toFixed(decimals).toString();
  };

  static dottedString = (x) => {
    return `${x?.slice(0, 6)}...${x?.slice(36, 42)}`;
  };

  static objectToParams = (obj) => {
    let str = "";
    for (const key in obj) {
      if (obj[key] !== undefined && obj[key] !== null) {
        if (str !== "") {
          str += "&";
        }
        str += key + "=" + encodeURIComponent(obj[key]);
      }
    }
    return str;
  };

  static toTitleCase = (phrase) =>
    phrase
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

  static timeoutPromise = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  static roundNumber = (num, decimals) => {
    const t = Math.pow(10, decimals);
    let result = Math.round((num + Number.EPSILON) * t) / t;
    if (num < 0) {
      result = result * -1;
    }
    return result;
  };

  static addressConvertor = (address) => {
    if ((address || "").length < 10) {
      return address || "";
    }
    return `${address.slice(0, 4)}...${address.slice(address.length - 4)}`;
  };

  static isValidURL = (str) => {
    const regex =
      /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
    return regex.test(str);
  };

  static copyToClipboard = (text: string, toastMessage?: string) => {
    ToastMessage("Copied", toastMessage, "success");
    navigator.clipboard.writeText(text);
  };

  static csvToJson = async (event: any, setJson) => {
    if (event.target.files && event.target.files.length > 0) {
      const files = event.target.files;
      if (files) {
        await Papa.parse(files[0], {
          complete: (results) => {
            setJson(results.data);
          },
          header: true,
          skipEmptyLines: true,
        });
      }
    }
  };
  static ipfsClient = async (file) => {
    try {
      const address: any = "https://ipfs.infura.io:5001/api/v0";
      const client = create(address);
      const result = await client.add(file);
      const url = `${app.IPFS_PATH}/${result.path}`;
      return url;
    } catch (error) {
      console.log(error, "ipfsError");
    }
  };
  static networkShould = (chainId: any) => {
    switch (chainId) {
      case "137":
      case "0x89":
        return true;
        break;
      case "0x4":
      case "4":
        return true;
        break;
      case "0x1":
      case "1":
        return true;
        break;
      default:
        return false;
    }
  };

  static makeNftId = (tokenAddress, tokenId) => {
    return `${tokenAddress}-${tokenId}`;
  };
  static deStructureNftId = (nftId) => {
    const tokenId = nftId.substring(nftId.indexOf("-") + 1).trim();
    const tokenAddress = nftId.substring(0, nftId.indexOf("-")).trim();
    return {
      tokenAddress,
      tokenId,
    };
  };

  static mm_dd_yy = (date: Date) => {
    const d = new Date(date);
    let month = (d.getMonth() + 1).toString();
    let day = d.getDate().toString();
    const year = d.getFullYear();
    if (month.length === 1) month = `0${month}`;
    if (day.length === 1) day = `0${day}`;
    return `${month}-${day}-${year}`;
  };

  static mm_yy = (date: Date) => {
    const d = new Date(date);
    let month = d.getMonth().toString();
    const year = d.getFullYear();

    switch (month) {
      case "0":
        month = "January";
        break;
      case "1":
        month = "Feburary";
        break;
      case "2":
        month = "March";
        break;
      case "3":
        month = "April";
        break;
      case "4":
        month = "May";
        break;
      case "5":
        month = "June";
        break;
      case "6":
        month = "July";
        break;
      case "7":
        month = "August";
        break;
      case "8":
        month = "September";
        break;
      case "9":
        month = "October";
        break;
      case "10":
        month = "November";
        break;
      case "11":
        month = "December";
        break;
    }
    return `${month} ${year}`;
  };

  static validatePattern = (pattern, value) => {
    const regex = new RegExp(pattern);
    return regex.test(value);
  };

  static imagePreview = (file) => {
    if (file && file.type.match("image.*")) {
      const url = URL.createObjectURL(file);
      return url;
    }
  };
  static dynamicSort = (property: string) => {
    let sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return (a: any, b: any) => {
      let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
      return result * sortOrder;
    }
  }

  static validateAddress = (address, token) => {
    var valid = WAValidator.validate(address, token);
    if (valid) {
      return valid;
    } else {
      return valid;
    }
  };
}
